import { COLORS } from 'helpers/globals'

const buttonDefault = {
  float: 'right',
  marginRight: '1rem'
}

export default {
  floorPlanDetails: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 435,
    height: '100%',
    overflowY: 'auto',
    padding: 0
  },
  topUiControls: {
    fontSize: '1.6rem',
    padding: '.5rem',
    backgroundColor: COLORS.tertiary,
    borderBottom: `1px solid ${COLORS.quaternary}`
  },
  container: {
    padding: '.8rem',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    color: 'black'
  },
  floorPlanActions: {
    position: 'absolute',
    right: '1rem',
    top: '1.4rem',
    zIndex: 1
  },
  goBackButton: {
    marginRight: 7
  },
  targetButton: {
    fontSize: '2rem',
    ...buttonDefault,
    lineHeight: '2rem'
  },
  lockButton: {
    ...buttonDefault,
    marginRight: 0,
    lineHeight: '2rem',
    fontSize: '2rem'
  },
  destroyButton: {
    color: 'red',
    fontSize: '1.9rem',
    ...buttonDefault
  },
  nameLabel: {
    lineHeight: '3.5rem',
    color: 'black',
    flex: '0 0 15%'
  },
  textWrapper: {
    flex: '1 1 auto',
    margin: 'auto'
  },
  nameInput: {
    width: '82% !important'
  },
  buttonContainer: {
    margin: '1rem 0 0 7rem',
    display: 'flex'
  },
  scaleButton: {
    fontSize: '1.4rem',
    background: COLORS.primary,
    color: 'white',
    borderRadius: 2,
    padding: '.75rem 1.5rem',
    '&:hover': {
      background: '#68B1F0',
      color: 'white'
    }
  },
  scaleIcon: {
    fontSize: '2rem',
    marginRight: '.5rem',
    verticalAlign: '-5px'
  },
  label: {
    lineHeight: '3.5rem',
    color: 'black',
    flex: '0 0 15%'
  },
  sliderContainer: {
    margin: '1rem 2rem 1rem 1rem',
    flex: '1 1 75%'
  }
}



// WEBPACK FOOTER //
// ./src/components/FloorPlan/FloorPlanDetails/style.js